import { Box, Button, IconButton, MenuItem, Popover, Select, TextField, Typography, useTheme } from '@mui/material'
import React from 'react'
import JoinMeetingHeader from '../../components/webinar-room/JoinMeetingHeader'
import { Link, useNavigate } from 'react-router-dom'
import { Icons } from '../../utils/utilities'
import { useThemeContext } from '../../contexts/theme.context'
import { useState } from 'react'
import aliveLogo from '../../assets/alivelogo.png'
import { useRef } from 'react'
import { toast } from 'react-toastify'

const isValidUUID = ( uuid ) => {
    const uuidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/
    return uuidRegex.test( uuid )
}

const OnlineMeetingsHome = () => {

    const [settingsAnchorEl, setSettingsAnchorEl] = useState( null )

    const { selectedTheme, setSelectedTheme, themeOptions } = useThemeContext()
    const { palette } = useTheme()
    const navigate = useNavigate()

    const meetingLinkInputRef = useRef()

    const handleThemeChange = e => {
        setSelectedTheme( e.target.value )
        localStorage.setItem( 'preferedTheme', e.target.value )
        setSettingsAnchorEl( null )
    }
    const goToMeeting = () => {
        const value = ( meetingLinkInputRef.current.value || "" ).trim()
        console.log( value )

        if ( isValidUUID( value ) ) {
            navigate( `/meeting/${value}`, { replace: true } )
        } else {
            toast( "Invalid meeting ID!" )
        }
    }

    return (
        <Box bgcolor={palette.background.paper} display="flex" flexDirection="column" gap="20px" height="100%" alignItems="center" justifyContent="center" padding="20px">

            <Box position="fixed" top="0" width="100vw" bgcolor={palette.background.paper} alignItems="center" justifyContent=" space-between" height={`${50}px`} display="flex" maxWidth="100%" padding={{ md: "20px 40px", xs: "20px 10px" }} sx={{ transition: "0.2s ease-out" }}>
                <Link to={`/meetings`} className='default-link' >
                    <Box display="flex" gap="10px" alignItems="center">
                        <Box component="img" width="30px" src={aliveLogo} alt="Alive Logo" />
                        <Typography variant='h6' fontWeight="300" fontSize={{ sm: "16px", xs: "14px" }}>{`Alive Online Meetings and Webinars`}</Typography>
                    </Box>
                </Link>
                {<Box display="flex" alignItems="center" gap="10px">
                    <Box display={{ sm: "block", xs: "none" }}>
                        <Typography marginBottom="-5px" textAlign="right" variant='subtitle1' textTransform="capitalize">{new Date().toLocaleDateString( 'en-IN', { month: "long", year: "numeric", day: "2-digit" } )}</Typography>
                    </Box>
                    <IconButton onClick={( e ) => setSettingsAnchorEl( e.currentTarget )}>
                        {Icons.default.SettingsOutlined}
                    </IconButton>
                    <Popover disableAutoFocus disableEnforceFocus disableRestoreFocus transformOrigin={{ horizontal: 'right', vertical: 'top' }} anchorOrigin={{ horizontal: 'left', vertical: 'top' }} elevation={1} open={Boolean( settingsAnchorEl )} onClose={() => setSettingsAnchorEl( null )} slotProps={{ paper: { sx: { maxWidth: "300px" } } }} anchorEl={settingsAnchorEl}>
                        <Box padding="10px" display="flex" gap="20px" alignItems="center">
                            <Typography width="max-content" variant="variant2">Theme</Typography>
                            <Select sx={{ height: "25px", textTransform: "capitalize" }} size="small" value={selectedTheme} onChange={handleThemeChange} >
                                {themeOptions.map( theme => (
                                    <MenuItem key={theme} value={theme} dense sx={{ fontSize: "14px", textTransform: "capitalize" }}>{theme}</MenuItem>
                                ) )}
                            </Select>
                        </Box>
                    </Popover>
                </Box>}
            </Box>

            <Typography textAlign="center" variant='h4'>Welcome to Alive Meetings and Webinars</Typography>
            {/* <Box display="flex" alignItems="center" gap="20px" > */}
            <TextField fullWidth inputRef={meetingLinkInputRef} sx={{ maxWidth: "300px" }} slotProps={{ htmlInput: { sx: { textAlign: "center" } }, input: { sx: { borderRadius: "50px", textAlign: "center" } } }} placeholder='Enter meeting ID' />
            <Button variant='contained' disableElevation onClick={goToMeeting} >Join</Button>
            {/* </Box> */}
        </Box>
    )
}

export default OnlineMeetingsHome
